import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ typography }: Theme) =>
  createStyles({
    headerContent: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '6px 6px 0px 10px',
      flexBasis: 'auto',
    },
    loadingContent: {
      padding: 24.5,
    },
    container: {
      minHeight: 180,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    header: {
      padding: '5px 0px 0px 0px',
      '& .MuiTypography-root': {
        fontWeight: typography.fontWeightMedium,
        color: palette.darkerGray,
        fontSize: 15,
      },
      '& .MuiCardHeader-subheader': {
        fontSize: 12,
        opacity: 0.5,
      },
    },

    content: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 5,
      height: '100%',
    },

    value: {
      fontSize: 70,
      fontWeight: 500,
      textAlign: 'center',
      color: palette.gray,
      lineHeight: 1,

      '& small': {
        display: 'block',
        fontSize: 25,
        paddingBottom: 5,
      },
    },

    percent: {
      display: 'flex',
      alignItems: 'center',
      color: 'red',
      fontSize: 14,
    },

    negative: {
      color: palette.status.error,
    },
    equal: {
      color: palette.blue,
    },
    positive: {
      color: palette.status.success,
    },

    icon: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 40,
      height: 40,
      borderRadius: 20,
      marginRight: 8,
      position: 'relative',
      overflow: 'hidden',

      '&:before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: 'currentColor',
        opacity: 0.1,
      },
    },
    footer: {
      borderTop: `1px solid ${palette.divider}`,
      padding: '5px 5px 5px 10px',
      display: 'flex',
      justifyContent: 'start',
      '&:disabled': {
        opacity: 0.7,
      },
    },
    footerName: {
      fontWeight: typography.fontWeightMedium,
      fontSize: 12,
    },
  });
